import React, { useMemo } from 'react'
import './CfoSite.css'
import { CfoBrandMark } from './CfoSiteShared'

function checkoutSessionId(): string {
  if (typeof window === 'undefined') return ''
  return String(new URLSearchParams(window.location.search).get('session_id') || '').trim()
}

export function CfoCheckoutCompletePage() {
  const sessionId = useMemo(() => checkoutSessionId(), [])

  return (
    <div className="cfo-site">
      <div className="cfo-center">
        <main className="cfo-panel cfo-center-text" aria-live="polite">
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 18 }}>
            <CfoBrandMark sub="by FuseGrid" />
          </div>

          {!sessionId ? (
            <>
              <div className="cfo-checkout-orb cfo-checkout-orb-warn" aria-hidden="true">!</div>
              <h1>This checkout confirmation link is incomplete.</h1>
              <p className="sub">
                Check your email for a Stripe receipt. If you received one, your payment was submitted.
              </p>
              <p className="cfo-prose">
                Need help? Email <a href="mailto:hello@fusegrid.io">hello@fusegrid.io</a> and we’ll verify it for you.
              </p>
            </>
          ) : (
            <>
              <div className="cfo-checkout-orb" aria-hidden="true">✓</div>
              <div className="cfo-eyebrow">Payment submitted</div>
              <h1>Your checkout is complete.</h1>
              <p className="sub">
                Stripe has emailed a confirmation to the billing address used at checkout.
              </p>
              <p className="cfo-prose"><strong>You’re all set.</strong> You can safely close this tab.</p>
              <a className="cfo-btn cfo-btn-primary" href="/">Continue to FuseGrid</a>
            </>
          )}
        </main>
      </div>
    </div>
  )
}

export default CfoCheckoutCompletePage
